import {
  QueryViewerFeedNotificationsResponse,
  Status,
} from '@wix/ambassador-notifications-members-feed-v1-members-viewer-feed-notification/types';
import Chance from 'chance';
import {
  getDayAgo,
  getHourAgo,
} from '../../components/OoiNotifications/Widget/utils/date';
import type { OOIControllerFlowAPI } from '@wix/yoshi-flow-editor-runtime/build/cjs/flow-api/OOIController';

const chance = new Chance();

export const shouldGetDummyData = (flowAPI: OOIControllerFlowAPI) =>
  flowAPI.environment.isEditor || flowAPI.environment.isPreview;

export const getDummyNotifications = (
  flowAPI: OOIControllerFlowAPI,
): QueryViewerFeedNotificationsResponse => {
  return {
    viewerFeedNotifications: [
      {
        id: chance.guid(),
        message: flowAPI.translations.t('app.widget.dummy-data.message.1'),
        sentDate: new Date(),
        status: Status.UNSEEN,
      },
      {
        id: chance.guid(),
        message: flowAPI.translations.t('app.widget.dummy-data.message.2'),
        sentDate: getHourAgo(),
        status: Status.UNSEEN,
      },
      {
        id: chance.guid(),
        message: flowAPI.translations.t('app.widget.dummy-data.message.3'),
        sentDate: getDayAgo(),
        status: Status.READ,
      },
    ],
    pagingMetadata: {
      count: 3,
      cursors: {},
      hasNext: false,
    },
  };
};
